
import { useState } from "react";
import { useContext } from "react";
import Sidebar from "./scenes/global/Sidebar";
import { CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { CheckInOutProvider } from "./CheckInOutContext"
import { UserContext } from './UserContext';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import "@fortawesome/fontawesome-free/css/all.min.css"
import sidebar_mapping from "./sidebar_mapping.json";
import InternalRoutesRenderer from "./InternalRoutesRenderer";
import SidebarRouteRenderer from "./SidebarRouteRendere";
import get_config from "./get_config.json";
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
function App() {
  const [theme, colorMode] = useMode();
  const { isLoggedIn, setIsLoggedIn } = useContext(UserContext);

  const isScreenBelow900 = useMediaQuery("(max-width:900px)");

  return (
    <>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <CheckInOutProvider>
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {isLoggedIn && <CssBaseline />}
        {/* 
          1. Give the main app container a defined height.
             Using 100vh (100% of the viewport height) is a common way to do this.
        */}
        <div className="app" style={{ display: 'flex', height: '100vh' }}>
          {isLoggedIn && <Sidebar setIsLoggedIn={setIsLoggedIn} /> }
          
          {/* 
            2. Use a semantic tag like <main> for the content area.
               Add overflowY: 'auto' to make it scrollable.
          */}
          <main style={{ flex: 1, overflowY: 'auto' }}>
            {/*
              3. Add an inner div for padding. This prevents your content
                 from touching the edges of the scrollbar area.
            */}
            <div style={{ padding: '20px' }}>
              <InternalRoutesRenderer sidebar_mapping={sidebar_mapping} />
              {isLoggedIn && <SidebarRouteRenderer get_config={get_config} />}
              {isLoggedIn && <ReactNotifications />}
            </div>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  </CheckInOutProvider>
</LocalizationProvider>
    </>
  );
}

export default App;



